import axios from "axios";
const BASE_URL = process.env.REACT_APP_API_URL + "/api/bpjs"; 

export const getBpjsKaryawan = async (periode) => {
  const response = await axios.get(`${BASE_URL}?periode=${periode}`);
  return response.data;
};

export const getBpjsByKaryawan = async (id) => {
  const response = await axios.get(`${BASE_URL}/${id}`);
  return response.data;
};

export const bulkInsertBpjs = async (data) => {
  const response = await axios.post(`${BASE_URL}/bulk`, data);
  return response.data;
};

export const bulkUpdateBpjs = async (data) => {
  const response = await axios.put(`${BASE_URL}/bulk`, data);
  return response.data;
};

export const bulkDeleteBpjs_ = async (ids) => {
  const response = await axios.delete(`${BASE_URL}/bulk`, { ids });
  return response.data;
};

export const bulkDeleteBpjs = (ids) =>
  axios({
    method: "delete",
    url: `${BASE_URL}/bulk/`,
    data: { ids },
  });